<template>
    <v-list-group class="mb-2 ml-4 mr-4 search"

            prepend-icon="face"
            no-action
            >

            <v-list-tile slot="activator">
                <v-list-tile-title  >{{ groupTitle }}</v-list-tile-title>
            </v-list-tile>
            <EmployeeAutocomplete :key="reset" class="ml-5  mr-1" :label="occupantLabel" :singleline="true" v-on:return-employee="setEmployeeOccupant"/>
            <EmployeeAutocomplete :key="reset+100" class="ml-5 mb-4 mr-1" :label="piLabel" :singleline="true" v-on:return-employee="setEmployeePI"/>
    </v-list-group>
</template>

<script>
    import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
    import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete'

    let SearchPeople = {

        data() {
            return {
                employee: null,
                selected: null,
                groupTitle :    "People",
                piLabel: "Principal Investigator",
                occupantLabel: "Occupant",
                reset: 1,
            }
        },

        components: { EmployeeAutocomplete },

/*        watch: {
            searchResults (val) {
                if (val) {
                    this.piLabel="TestChangeBack"
                    this.occupantLabel="TestChangeBack"
                    return
                }
            }
        },*/

        computed: {
            ...mapState({             
                            searchResults: state => state.search.searchResults,
            }),

            items : function () { return this.$store.state.space.PIs },
        },

        methods: {
            ...mapActions(['selectBuilding', 'fetchPI', 'fetchOccupant']),

            ...mapMutations([   'setSearchResults',
                                'setSearchTitle',
                                'setSearchSubtitle',
                                'setSearchExportText',
                                'setSearchSort',
                                'setSelectedRoom',
                                'updateSearchResultSidebar',
                                'updateMainSidebar',
                                'setSnackText',
                                'clearSearch',
                            ]),

            setEmployeeOccupant(value) {
                if (!value) {return}
                this.employee = value
                this.submitSearchOccupant(this.employee.employeeID)
            },

            setEmployeePI(value) {
                if (!value) {return}
                this.employee = value
                this.submitSearchPI(this.employee.employeeID)
            },

            submitSearchOccupant(value) {
                this.reset += 1
                this.clearSearch()
                this.fetchOccupant(value).then((data) => {
                    if (!data) {this.setSnackText("No Results Found"); return }
                    
                    // Add nice text
                    if (data.titleHighest) {
                        this.setSearchExportText(data.name + ", " + data.titleHighest)
                    }
                    else {
                        this.setSearchExportText(data.name)
                    }

                    this.setSearchResults(data)
  
                    const subtitle =    `<div style="background-color: #383838;color: white;padding: 25px;margin-left: -25px;
                                                margin-top: -25px;">
                                                <div class="headline">${data.name}</div>
                                                <div style="margin-bottom: 10px;">${data.titleHighest ? data.titleHighest : ""}</div>
                                                <div>Total Area: ${data.areaSum.toLocaleString()}</div>
                                                <div>Bldg Count: ${data.bldgCount}</div>
                                                <div>Room Count: ${data.roomCount}</div>

                                        `

                    this.setSearchTitle("Occupant Search")
                    this.setSearchSubtitle(subtitle)
                    this.setSearchSort("name")
                    this.updateMainSidebar(false)  
                    this.updateSearchResultSidebar(true)
                }) 
            },
            
            submitSearchPI(value) {
                this.reset += 1
                this.clearSearch()
                this.fetchPI(value).then((data) => {
                    if (!data) {this.setSnackText("No Results Found"); return }

                    

                    this.setSearchResults(data)                                        

                    const subtitle =    `<div style="background-color: #383838;color: white;padding: 25px;margin-left: -25px;
                                                margin-top: -25px;">
                                                <div class="headline">${data.name}</div>
                                                <div style="margin-bottom: 10px;">${data.titleHighest ? data.titleHighest : ""}</div>
                                                <div>Total Area: ${data.areaSum.toLocaleString()}</div>
                                                <div>Bldg Count: ${data.bldgCount}</div>
                                                <div>Room Count: ${data.roomCount}</div>

                                        `

                    this.setSearchTitle("Principal Investigator Search")
                    this.setSearchSubtitle(subtitle)
                    
                    if (data.titleHighest) {
                        this.setSearchExportText(data.name + ", " + data.titleHighest)
                    }
                    else {
                        this.setSearchExportText(data.name)
                    }
                    this.setSearchSort("name")    
                    this.updateMainSidebar(false)            
                    this.updateSearchResultSidebar(true)

                }) 
            },
        }
    }

    export default SearchPeople
</script>

<style>
.v-list__group__header--sub-group > .v-list__group__header__prepend-icon {
    padding: 0px !important;
    min-width: 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/search/SearchPeople.vue